module.exports = __webpack_public_path__ + "static/media/xilinx.fb652692.svg";